<div>
    <div class="document-list-header">
        <div class="header-title">Dokumente</div>
        <div class="mini-hex-button rightmost">
            <app-file-upload [buttonIcon]="'Add'" [allowMultipleUploads]="true" [acceptedFileTypes]="'*'"
                (selected)="setNewFileIds('Dokumente', $event)"></app-file-upload>
        </div>
    </div>
    <div *ngFor="let documentId of documentFileIds; let i = index" class="document-table-row">
        <div style="word-break: break-all; padding-left: 8px;">{{ getNameOfDocument(documentId) }}</div>
        <div class="arrow-panel">
            <button mat-icon-button class="arrow-icon" (click)="moveUpDocument(i)" [disabled]="i == 0">
                <mat-icon> arrow_drop_up </mat-icon>
            </button>
            <button mat-icon-button class="arrow-icon" (click)="moveDownDocument(i)"
                [disabled]="i == documentFileIds.length - 1">
                <mat-icon> arrow_drop_down </mat-icon>
            </button>
        </div>
        <red-cross-button class="rightmost" (click)="removeDocument(i)"></red-cross-button>
    </div>

    <div class="document-list-header">
        <div class="header-title">{{ galleryTitle }}</div>
        <div class="mini-hex-button rightmost">
            <app-file-upload [buttonIcon]="'Add'" [allowMultipleUploads]="true" [acceptedFileTypes]="'image/*'"
                (selected)="setNewFileIds('Galerie', $event)"></app-file-upload>
        </div>
    </div>
    <div *ngFor="let galleryId of galleryFileIds; let i = index" class="gallery-row"
        [class]="{ 'border-below': i != galleryFileIds.length - 1 }">
        <img class="img" [src]="getFilePath(galleryId)" />
        <div class="gallery-button-panel">
            <div></div>
            <div class="arrow-panel">
                <button mat-icon-button class="arrow-icon" (click)="moveGalleryFileUp(i)" [disabled]="i == 0">
                    <mat-icon> arrow_drop_up </mat-icon>
                </button>
                <button mat-icon-button class="arrow-icon" (click)="moveGalleryFileDown(i)"
                    [disabled]="i == galleryFileIds.length - 1">
                    <mat-icon> arrow_drop_down </mat-icon>
                </button>
            </div>
            <red-cross-button class="rightmost" (click)="removeGalleryImage(i)"></red-cross-button>
        </div>
    </div>
</div>